import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News2ComponentState {
    activeLanguage: string | undefined;
}

@Component({
    selector: "dtm-main-page-lib-news-3",
    templateUrl: "./news-3.component.html",
    styleUrls: ["./news-3.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News3Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<News2ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
